import { render, staticRenderFns } from "./CustomsDeclareImport.vue?vue&type=template&id=65496813&"
import script from "./CustomsDeclareImport.vue?vue&type=script&lang=js&"
export * from "./CustomsDeclareImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports